import { ApocalypseFreespinResultPresentation } from "../freespin/ApocalypseFreespinResultPresentation";

export class ApocalypseSuperFreespinResultPresentation extends ApocalypseFreespinResultPresentation {
    constructor() {
        super(`ApocalypseSuperFreespinResultPresentation`);
    }
}
